export const IMPORTED_CONSTS = {
  VEHICLE_TYPE: 'osobní',
} as const;
